import { useEffect, useState } from 'react';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { evaluateInAppRpc } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const usePurchaseMotionForAssignability = ({
  isAssignable,
  apiName
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [purchaseMotion, setPurchaseMotion] = useState();
  useEffect(() => {
    if (isAssignable === undefined) {
      rpcClient.call(evaluateInAppRpc, {
        request: {
          productApiNames: [apiName],
          locations: ['TALK_TO_SALES_BUTTON']
        }
      }).then(response => {
        const purchaseMotions = response.purchaseMotionsMapping.productsByLocation.TALK_TO_SALES_BUTTON.purchaseMotionsByProductApiName[apiName].purchaseMotions || ['TALK_TO_SALES_FALLBACK'];
        setPurchaseMotion(purchaseMotions[0]);
        setLoading(false);
      }).catch(e => {
        setError(e);
        setLoading(false);
      });
    } else {
      setPurchaseMotion(isAssignable ? 'TALK_TO_SALES' : 'TALK_TO_SALES_FALLBACK');
      setLoading(false);
    }
  }, [apiName, isAssignable]);
  return {
    loading,
    error,
    purchaseMotion
  };
};